import { useState, useEffect } from 'react';
import { C, NAV } from './utils/constants';
import { ConfigDropdown } from './components/shared/ui.jsx';
import { Link, useParams, useNavigate } from 'react-router-dom';
import logo from './assets/logo/probestackLogo.png';
import "./style.css";
import AppRoutes from './AppRoutes.jsx';
import { initAuth } from './http-service/client.js';


export default function App() {
  const [configValue, setConfigValue] = useState('');
  const navigate = useNavigate();

  useEffect(() => {
    initAuth(); 
  }, []);

  const handleChange = (value) => {
    setConfigValue(value);

    const routeMap = {
      git: "/configs/git",
      gcs: "/configs/storage",
      standard: "/configs/api-standard-linting",
      custom: "/configs/api-custom-linting",
    };

    navigate(routeMap[value]);
  };

  return (
    <div style={{
      display: "flex",
      minHeight: "100vh",
      background: C.deep,
      color: C.white,
      fontFamily: "Inter, system-ui, -apple-system, Segoe U, Roboto, Ubuntu, sans-serif"
    }}>
      <div style={{
        width: 190,
        flexShrink: 0,
        background: C.navy,
        borderRight: `1px solid ${C.border}`,
        display: "flex",
        flexDirection: "column",
        position: "sticky",
        top: 0,
        height: "100vh",
        overflowY: "auto"
      }}>
        <div className='logo-header' style={{ padding: ".6rem 1rem", borderBottom: `1px solid ${C.border}` }}>
          <img src={logo} alt="" srcset="" style={{ width: "auto", height: "3rem" }} />
          <div style={{ display: "flex", flexDirection: 'column' }}>
            <div className='gradient-text text-xl font-extrabold'
              style={{
                fontFamily: "Inter, system-ui, -apple-system, Segoe U, Roboto, Ubuntu, sans-serif",
                display: "flex",
                alignItems: "center",
                gap: ".6rem"
              }}>
              ForgeAI
            </div>
            <span class="sub-text-logo text-muted-foreground leading-tight">A ForgeCrux Product</span>
          </div>
        </div>
        <nav style={{ flex: 1, padding: "8px 7px" }}>
          {NAV.map(item => {
            const NavItem = () => {
              const { pageId } = useParams();
              const active = pageId === item.id;
              return (
                <Link
                  to={`/${item.id}`}
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: ".5rem",
                    width: "100%",
                    padding: ".7rem",
                    borderRadius: 6,
                    border: "none",
                    cursor: "pointer",
                    fontSize: ".8rem",
                    fontWeight: active ? 600 : 400,
                    marginBottom: 1,
                    textAlign: "left",
                    background: active ? `${C.orange}15` : "transparent",
                    color: active ? C.orange : C.muted,
                    borderLeft: `2px solid ${active ? C.orange : "transparent"}`,
                    transition: "all .15s",
                    fontFamily: "Inter, system-ui, -apple-system, Segoe U, Roboto, Ubuntu, sans-serif",
                    textDecoration: "none"
                  }}
                >
                  <span style={{ fontSize: 12 }}>{item.icon}</span>
                  {item.label}
                </Link>
              );
            };
            return <NavItem key={item.id} />;
          })}
        </nav>
        <div style={{ padding: "9px 10px", borderTop: `1px solid ${C.border}` }}>
          <div style={{
            background: "rgba(57,181,74,.1)",
            border: `1px solid rgba(57,181,74,.25)`,
            borderRadius: 6,
            padding: "6px 8px",
            display: "flex",
            alignItems: "center",
            gap: 6
          }}>
            <span style={{
              width: 5,
              height: 5,
              borderRadius: "50%",
              background: C.green,
              boxShadow: `0 0 5px ${C.green}`,
              flexShrink: 0
            }} />
            <div>
              <div style={{ fontSize: 8, fontWeight: 700, color: C.green }}>Apigee X Connected</div>
              <div style={{ fontSize: 7, color: C.dim }}>my-gcp-project · prod</div>
            </div>
          </div>
        </div>
      </div>
      <div style={{ flex: 1, display: "flex", flexDirection: "column", overflow: "hidden" }}>
        <div style={{
          background: C.navy,
          borderBottom: `1px solid ${C.border}`,
          padding: "10px 20px",
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          position: "sticky",
          top: 0,
          zIndex: 50,
          height: "68.1875px"
        }}>
          <div style={{ fontSize: 9, color: C.dim, fontFamily: "monospace" }}>
            probestack.io / ai-gateway / dashboard
          </div>
          <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
            {[
              // ["APIGEE X LIVE", C.cyan],
              ["MODEL ARMOR ON", C.green]
            ].map(([label, color]) => (
              <div key={label} style={{
                background: `${color}10`,
                border: `1px solid ${color}33`,
                borderRadius: 4,
                padding: "2px 8px",
                fontSize: 8,
                color,
                fontWeight: 700,
                letterSpacing: ".08em"
              }}>
                {label}
              </div>
            ))}
            <ConfigDropdown value={configValue} onChange={handleChange} />
            <div className="header-actions">

              {/* Theme Toggle */}
              <button className="header-btn" aria-label="Toggle theme">
                <svg className="icon" viewBox="0 0 24 24">
                  <circle cx="12" cy="12" r="4"></circle>
                  <path d="M12 2v2"></path>
                  <path d="M12 20v2"></path>
                  <path d="m4.93 4.93 1.41 1.41"></path>
                  <path d="m17.66 17.66 1.41 1.41"></path>
                  <path d="M2 12h2"></path>
                  <path d="M20 12h2"></path>
                  <path d="m6.34 17.66-1.41 1.41"></path>
                  <path d="m19.07 4.93-1.41 1.41"></path>
                </svg>
              </button>

              {/* User Dropdown */}
              <div className="header-dropdown">
                <button className="header-btn">
                  <svg className="icon" viewBox="0 0 24 24">
                    <path d="M19 21v-2a4 4 0 0 0-4-4H9a4 4 0 0 0-4 4v2"></path>
                    <circle cx="12" cy="7" r="4"></circle>
                  </svg>
                  <svg className="icon-sm" viewBox="0 0 24 24">
                    <path d="m6 9 6 6 6-6"></path>
                  </svg>
                </button>
              </div>

              {/* Logout */}
              <button className="header-btn">
                <svg className="icon" viewBox="0 0 24 24">
                  <path d="m16 17 5-5-5-5"></path>
                  <path d="M21 12H9"></path>
                  <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4"></path>
                </svg>
              </button>

            </div>
          </div>
        </div>
        <div style={{ padding: "20px 22px",display: 'flex', flex: 1, overflowY: "auto" }}>
          <AppRoutes />
        </div>
      </div>
    </div>
  );
}
